import React, { FunctionComponent } from "react";
import { AddressAutocompleteItem } from "./AddressAutoCompleteItem";
import { APIProvider } from "@vis.gl/react-google-maps";

import "./AddressAutoComplete.css";

type AddressAutoCompleteProps = {
  onPlaceSelect: (place: google.maps.places.Place | null) => void;
};

/**
 * Auto complete control for addresses.
 * Based on: https://visgl.github.io/react-google-maps/examples/autocomplete
 */
const AddressAutoCompleteBase: FunctionComponent<AddressAutoCompleteProps> = ({
  onPlaceSelect,
}) => {
  return (
    <APIProvider apiKey={VisitWidget.settings.mapBrowserApiKey}>
      <AddressAutocompleteItem onPlaceSelect={onPlaceSelect} />
    </APIProvider>
  );
};

const AddressAutoComplete = React.memo(AddressAutoCompleteBase);

export { AddressAutoComplete };
